export default __webpack_public_path__ + "static/media/trampapo_02_29.9bc57b1a.jpg";